import { api } from './client';

export interface LicenseStatus {
  status: 'none' | 'active' | 'revoked';
  purchased_at: number | null;
  license_key: string | null;
  device_slot: { used: number; max: number };
}

export const licenseApi = {
  verify: () => api.get('api/license/verify').json<LicenseStatus>(),

  checkout: (returnUrl: string, cancelUrl: string) =>
    api
      .post('api/license/checkout', {
        json: { return_url: returnUrl, cancel_url: cancelUrl },
      })
      .json<{ checkout_url: string; session_id: string }>(),
};
